<main *ngIf="data" class="niva-page">
	<section
		class="niva-hero"
		*ngIf="data.hero_image || data.hero_title || data.hero_text"
	>
		<img
			*ngIf="data.hero_image?.url"
			class="niva-hero__image"
			[src]="data.hero_image.url"
			[alt]="data.hero_image.alt || ''"
		/>

		<div class="container niva-hero__content">
			<div class="niva-hero__text-card">
				<h1
					*ngIf="data.hero_title"
					class="niva-hero__title"
					[innerHTML]="data.hero_title"
				></h1>
				<div
					*ngIf="data.hero_text"
					class="niva-hero__text"
					[innerHTML]="data.hero_text"
				></div>

				<a
					*ngIf="data.hero_cta_label && data.hero_cta_link"
					class="niva-hero__button ga-choose-a-bottle"
					[href]="data.hero_cta_link"
				>
					{{ data.hero_cta_label }}
				</a>
			</div>
		</div>
	</section>

	<section class="niva-benefits" *ngIf="data.niva_benefits?.length">
		<div class="container niva-benefits__list niva-benefits__list--desktop">
			<div
				class="niva-benefits__item"
				*ngFor="let benefit of data.niva_benefits"
			>
				<img
					*ngIf="benefit.icon?.url"
					class="niva-benefits__icon"
					[src]="benefit.icon.url"
					[alt]="benefit.icon.alt || ''"
				/>
				<div
					*ngIf="benefit.text"
					class="niva-benefits__text"
					[innerHTML]="benefit.text"
				></div>
			</div>
		</div>

		<div class="niva-benefits__slider">
			<ngx-slick-carousel
				class="niva-benefits__carousel"
				[config]="benefitsSlideConfig"
			>
				<div
					ngxSlickItem
					class="niva-benefits__slide"
					*ngFor="let benefit of data.niva_benefits"
				>
					<div class="niva-benefits__item">
						<img
							*ngIf="benefit.icon?.url"
							class="niva-benefits__icon"
							[src]="benefit.icon.url"
							[alt]="benefit.icon.alt || ''"
						/>
						<div
							*ngIf="benefit.text"
							class="niva-benefits__text"
							[innerHTML]="benefit.text"
						></div>
					</div>
				</div>
			</ngx-slick-carousel>
		</div>
	</section>

	<section
		class="niva-about"
		*ngIf="data.about_title || data.about_description || data.about_image"
	>
		<div class="container niva-about__content">
			<div class="niva-about__text-card">
				<h2
					*ngIf="data.about_title"
					class="niva-about__title"
					[innerHTML]="data.about_title"
				></h2>
				<div
					*ngIf="data.about_description"
					class="niva-about__description"
					[innerHTML]="data.about_description"
				></div>
			</div>

            <div class="wrapper-image">
                <img
                    *ngIf="data.about_image?.url"
                    class="niva-about__image"
                    [src]="data.about_image.url"
                    [alt]="data.about_image.alt || ''"
                />
            </div>

		</div>
	</section>

	<section
		class="niva-cards"
		*ngIf="data.cards_title || data.niva_cards?.length"
	>
		<div class="container niva-cards__content">
			<h2
				*ngIf="data.cards_title"
				class="niva-cards__title"
				[innerHTML]="data.cards_title"
			></h2>

			<div class="niva-cards__grid">
				<article class="niva-cards__card" *ngFor="let card of data.niva_cards">
					<img
						*ngIf="card.image?.url"
						class="niva-cards__image"
						[src]="card.image.url"
						[alt]="card.image.alt || ''"
					/>

					<div class="niva-cards__overlay"></div>

					<div class="niva-cards__card-content">
						<h3
							*ngIf="card.title"
							class="niva-cards__card-title"
							[innerHTML]="card.title"
						></h3>
						<div
							*ngIf="card.description"
							class="niva-cards__description"
							[innerHTML]="card.description"
						></div>
					</div>
				</article>
			</div>
		</div>
	</section>

	<section
		class="niva-moment"
		*ngIf="
			data.moment_image ||
			data.moment_title ||
			data.moment_description ||
			data.niva_stats?.length ||
			data.niva_image_text?.length
		"
	>
		<div class="container niva-moment__content">
			<div class="niva-moment__highlight">
				<img
					*ngIf="data.moment_image?.url"
					class="niva-moment__image"
					[src]="data.moment_image.url"
					[alt]="data.moment_image.alt || ''"
				/>

				<div class="niva-moment__highlight-overlay"></div>

				<div class="niva-moment__highlight-text">
					<h2
						*ngIf="data.moment_title"
						class="niva-moment__title"
						[innerHTML]="data.moment_title"
					></h2>
					<div
						*ngIf="data.moment_description"
						class="niva-moment__description"
						[innerHTML]="data.moment_description"
					></div>
				</div>
			</div>

			<div class="niva-moment__side">
				<div class="niva-moment__stats" *ngIf="data.niva_stats?.length">
					<div class="niva-moment__stat" *ngFor="let stat of data.niva_stats">
                        <div class="d-flex align-items-end">
                            <strong
                                *ngIf="stat.number"
                                class="niva-moment__stat-number"
                                [innerHTML]="stat.number"
                            ></strong>
                            <span>ml</span>
                        </div>
						<div
							*ngIf="stat.text"
							class="niva-moment__stat-text"
							[innerHTML]="stat.text"
						></div>
					</div>
				</div>

				<div class="niva-moment__options" *ngIf="data.niva_image_text?.length">
					<div
						class="niva-moment__option"
						*ngFor="let item of data.niva_image_text"
					>
						<img
							*ngIf="item.image?.url"
							class="niva-moment__option-image"
							[src]="item.image.url"
							[alt]="item.image.alt || ''"
						/>
						<div
							*ngIf="item.text"
							class="niva-moment__option-text"
							[innerHTML]="item.text"
						></div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section
		class="niva-more"
		*ngIf="data.more_title || data.more_background_image || data.more_youtube_url"
		[style.background-image]="
			data.more_background_image?.url
				? 'url(' + data.more_background_image.url + ')'
				: null
		"
	>
		<div class="container niva-more__content">
			<h2
				*ngIf="data.more_title"
				class="niva-more__title"
				[innerHTML]="data.more_title"
			></h2>

			<div class="niva-more__video-card" *ngIf="moreYoutubeUrl">
				<iframe
					class="niva-more__video ga-watch-video"
					[src]="moreYoutubeUrl"
					title="Mais sobre a Niva"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					allowfullscreen
				></iframe>
			</div>
		</div>
	</section>

	<section
		class="niva-final-cta"
		*ngIf="data.cta_image || data.cta_title || data.cta_text"
	>
		<div class="container">
			<div class="niva-final-cta__content">
				<div class="niva-final-cta__text-card">
					<h2
						*ngIf="data.cta_title"
						class="niva-final-cta__title"
						[innerHTML]="data.cta_title"
					></h2>
					<div
						*ngIf="data.cta_text"
						class="niva-final-cta__text"
						[innerHTML]="data.cta_text"
					></div>

					<a
						*ngIf="data.cta_button_label && data.cta_button_link"
						class="niva-final-cta__button ga-buy-now"
						[href]="data.cta_button_link"
					>
						{{ data.cta_button_label }}
					</a>
				</div>
				<img
					*ngIf="data.cta_image?.url"
					class="niva-final-cta__image"
					[src]="data.cta_image.url"
					[alt]="data.cta_image.alt || ''"
				/>

			</div>
		</div>
	</section>
</main>
